import { useMemo } from 'react';

import { useMyItemsFilters } from '../../useDashboardStore';

const useGetClickthroughEnabled = () => {
  const {
    inheritedOwner,
    inheritedContributor,
    inheritedGroupOwner,
    inheritedGroupContributor,
  } = useMyItemsFilters();

  const clickThroughEnabled = useMemo(
    () =>
      !inheritedOwner &&
      !inheritedContributor &&
      !inheritedGroupOwner &&
      !inheritedGroupContributor,
    [
      inheritedContributor,
      inheritedGroupContributor,
      inheritedGroupOwner,
      inheritedOwner,
    ]
  );

  return clickThroughEnabled;
};

export default useGetClickthroughEnabled;
